import { Box, Text, TextProps } from '@cmpsr/components';

type VerifyEmailHeaderProps = TextProps & {
  variant: string;
  textStyle: string;
  color?: string;
  email: string;
};

export default function VerifyEmailHeader({ variant, textStyle, color, email, ...props }: VerifyEmailHeaderProps) {
  return (
    <Box>
      <Text variant={variant} mb="spacer-2" {...props}>
        Verify your{' '}
        <Text as="span" textStyle={textStyle} {...props}>
          email
        </Text>
      </Text>
      <Text variant="text-body-regular" color={color}>
        We just sent a temporary verification code to{' '}
        <Text as="span" variant="text-body-medium" color={color}>
          {email}
        </Text>
      </Text>
    </Box>
  );
}
